// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__7jPap","hero__bg":"Hero_hero__bg__nARSY","hero__overlay":"Hero_hero__overlay__rFuFh","hero__content":"Hero_hero__content__NIgqx"};